const STEPS = [
  {
    step: "Step 01",
    title: "Zero-Config Local Proxy",
    copy: "Interferes with zero developer habits. Intercepts local requests directly.",
    label: "[Proxy Listener]",
    image:
      "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxkYXJrJTIwZ2xvd2luZyUyMG5vZGVzJTIwZGF0YSUyMG5ldHdvcmslMjBhYnN0cmFjdHxlbnwwfHx8fDE3OTIwNjkyNzF8MA&ixlib=rb-4.1.0&q=85",
    stagger: "flint-stagger-1",
    testid: "feature-card-proxy",
  },
  {
    step: "Step 02",
    title: "Recoverable Distillation",
    copy: "Condenses repetitive files into lightweight semantic anchors.",
    label: "[Context Compression]",
    image:
      "https://images.unsplash.com/photo-1639322537228-f710d846310a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxkYXJrJTIwZ2xvd2luZyUyMG5vZGVzJTIwZGF0YSUyMG5ldHdvcmslMjBhYnN0cmFjdHxlbnwwfHx8fDE3OTIwNjkyNzF8MA&ixlib=rb-4.1.0&q=85",
    stagger: "flint-stagger-2",
    testid: "feature-card-distillation",
  },
  {
    step: "Step 03",
    title: "On-Demand Injection",
    copy: "Agent queries specific historical details only when explicitly needed.",
    label: "[Token Ledger]",
    image:
      "https://images.unsplash.com/photo-1758073519996-6d3c63b4922c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxkYXJrJTIwZ2xvd2luZyUyMG5vZGVzJTIwZGF0YSUyMG5ldHdvcmslMjBhYnN0cmFjdHxlbnwwfHx8fDE3OTIwNjkyNzF8MA&ixlib=rb-4.1.0&q=85",
    stagger: "flint-stagger-3",
    testid: "feature-card-injection",
  },
];

export const Features = () => {
  return (
    <section
      data-testid="features-section"
      className="max-w-6xl mx-auto px-6 py-24 border-b border-seam"
    >
      <div className="mb-12">
        <span className="text-xs font-semibold uppercase tracking-widest text-ember">
          Architecture
        </span>
        <h2 className="font-serif text-3xl sm:text-4xl text-white mt-1">
          Built for high-velocity coding agents
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {STEPS.map((s) => (
          <div
            key={s.step}
            data-testid={s.testid}
            className={`flint-fade ${s.stagger} rounded-xl border border-seam bg-coal p-5 flex flex-col justify-between`}
          >
            <div className="aspect-video w-full mb-4 rounded-lg border border-seam relative overflow-hidden">
              <img
                src={s.image}
                alt={s.title}
                className="flint-drift absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-ground/50" />
              <div className="absolute inset-0 flex items-center justify-center text-xs text-white/90 font-mono">
                {s.label}
              </div>
            </div>
            <div>
              <span className="text-ember text-xs font-semibold uppercase">
                {s.step}
              </span>
              <h3 className="text-lg font-semibold text-white mt-1 mb-2">
                {s.title}
              </h3>
              <p className="text-xs text-smoke leading-relaxed">{s.copy}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
